const defaultLanguage = 'en'
const otherLanguages = ['de', 'fr', 'it', 'pt-BR', 'es', 'ja']

function getAllLanguages() {
    const languages = [defaultLanguage, ...otherLanguages]
    return languages
}

module.exports = {
    defaultLanguage,
    otherLanguages,
    getAllLanguages,
}
